import { API } from "aws-amplify";

const show = async params => {
  let myInit = { // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: params
  };
  let items = await API.get("InasakuAPI", "/api/payment/card", myInit);

  return items;
};
const insert = async params => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    },
    headers: {} // OPTIONAL
  };
  let res = await API.post("InasakuAPI", "/api/payment", myInit);
  return res;
};
const del = async params => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    },
    headers: {} // OPTIONAL
  };
  let res = await API.del("InasakuAPI", "/api/payment", myInit);
  return res;
};
const update = async params => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    },
    headers: {} // OPTIONAL
  };
  let res = await API.put("InasakuAPI", "/api/payment/card", myInit);
  return res;
};

export default {
  show: show,
  insert: insert,
  del: del,
  update: update
};
